import { format } from 'date-fns';

import type { TrackingOrder } from '@/api/generated';

import { DetailField } from './DetailField.tsx';
import { PatientAvatar } from './PatientAvatar.tsx';
import { TrackingCard } from './TrackingCard.tsx';

type OrderDetailsCardProps = {
  order: TrackingOrder;
};

export function OrderDetailsCard({ order }: OrderDetailsCardProps) {
  const { patient, shipping_address, contact, created_at, placed_by } = order;

  const addressLines = shipping_address
    ? [
        shipping_address.street,
        shipping_address.complement,
        [
          [shipping_address.city, shipping_address.state].filter(Boolean).join(', '),
          shipping_address.zip_code,
        ]
          .filter(Boolean)
          .join(' '),
      ].filter(Boolean)
    : null;

  return (
    <TrackingCard title="Order details">
      <dl className="flex flex-col gap-4">
        <DetailField label="Patient">
          <div className="flex items-center gap-3">
            <PatientAvatar firstName={patient.first_name} lastName={patient.last_name} />
            <span>
              {patient.first_name} {patient.last_name}
            </span>
          </div>
        </DetailField>

        {addressLines && (
          <DetailField label="Ships to address">
            {addressLines.map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </DetailField>
        )}

        <DetailField label="Contact">
          <div className="flex flex-col gap-0.5">
            {contact.name && <span>{contact.name}</span>}
            {contact.phone_number && <span>{contact.phone_number}</span>}
            {contact.email && <span>{contact.email}</span>}
          </div>
        </DetailField>

        <DetailField label="Order placed" showDivider={false}>
          <div className="flex flex-col gap-0.5">
            <span>{created_at ? format(new Date(created_at), 'MMM d, yyyy') : 'Unknown'}</span>
            {placed_by && <span>by {placed_by}</span>}
          </div>
        </DetailField>
      </dl>
    </TrackingCard>
  );
}
